import './currenciesTabSkeleton.scss';

/** Filas skeleton del tab de monedas. */
const CurrenciesTabSkeleton = () => {
  const skeletonRows = Array(10).fill(null);

  return (
    <>
      {skeletonRows.map((_, index) => (
        <tr key={`currency-tab-skeleton-${index}`} className="currenciesTabSkeletonRow">
          <td className="currencyNameColumn">
            <div className="currencyRowInputZone currencyRowInputZoneStart">
              <div className="currencyNameSkeleton">
                <div className="currencyFlagSkeleton fullSkeleton" />
                <div className="currencyNameTextSkeleton fullSkeleton" />
              </div>
            </div>
          </td>

          <td className="exchangeRateColumn">
            <div className="exchangeRateSkeleton">
              <div className="exchangeRateLabelSkeleton fullSkeleton" />
              <div className="exchangeRateInputSkeleton fullSkeleton" />
            </div>
          </td>

          <td className="lastUpdateColumn">
            <div className="currencyRowInputZone currencyRowInputZoneStart">
              <div className="lastUpdateSkeleton fullSkeleton" />
            </div>
          </td>

          <td className="updatedByColumn">
            <div className="currencyRowInputZone currencyRowInputZoneStart">
              <div className="updatedBySkeleton fullSkeleton" />
            </div>
          </td>

          <td className="actionsColumn">
            <div className="currencyRowInputZone">
              <div className="saveButtonSkeleton fullSkeleton" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default CurrenciesTabSkeleton;
